module.exports = __webpack_public_path__ + "img/32.fdb37bb9.jpg";